import React from "react"
import { useTranslation } from "react-i18next"
import Breadcrumb from "../../../components/breadcrumb"
import { useSelector } from "react-redux"
import type { RootState } from "../../../store"

const breadcrumbs = [
  { name: "account.personal.breadcrumb.home", url: "/handbooks" },
  { name: "account.personal.breadcrumb.settings" }
]

const PersonalSettingsContainer: React.FC = () => {
  const { t } = useTranslation()
  const user = useSelector((state: RootState) => state.auth.user)

  return (
    <>
      <Breadcrumb data={breadcrumbs} />
      <h1 className="tw-font-display tw-font-semibold tw-text-4xl tw-mb-6">{t("account.personal.title")}</h1>
      <div className="tw-shadow tw-bg-white tw-rounded">
        <div className="tw-w-full tw-p-12">
          <h4 className="tw-mb-8">{t("account.personal.basicInfo")}</h4>
          <p>
            <b className="tw-pr-2">{t("account.personal.form.email")}:</b>
            {user?.email}
          </p>
          <p>
            <b className="tw-pr-2">{t("account.personal.form.name")}:</b>
            {user?.firstName} {user?.lastName}
          </p>
          <div className="tw-flex tw-space-x-4">
            <button
              type="button"
              disabled={true}
              className="tw-btn tw-h-8 tw-min-w-[20px] tw-my-4 tw-btn-primary tw-flex tw-items-center tw-justify-start">
              <span>{t("account.personal.button.edit")}</span>
            </button>
            <button
              type="button"
              disabled={true}
              className="tw-btn tw-h-8 tw-min-w-[20px] tw-my-4 tw-btn-primary tw-flex tw-items-center tw-justify-start">
              <span>{t("account.personal.button.changePassword")}</span>
            </button>
          </div>
          <p className="tw-text-xs">{t("account.personal.disclaimer")}</p>
        </div>
      </div>
    </>
  )
}

export default PersonalSettingsContainer
